import React, { useCallback, useState } from 'react';
import { TableCell, TableRow, Spinner } from '@client/toolkit';
import { getColors } from '../../../../styles/color-tokens';
import { useLazyGetInvoicesByIdDocumentQuery } from '@client/api';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { InvoiceReceivableDto } from '@client/api';
import { useAppSelector } from '../../../../hooks';
import { selectSelectedTenant } from '../../../../redux/session/session.slice';

export const InvoiceRow = ({ invoice }: { invoice: InvoiceReceivableDto }) => {
  const colors = getColors();
  const { t } = useTranslation('validation');
  const { t: tReporting } = useTranslation('reporting');
  const [getInvoicesByIdDocument] = useLazyGetInvoicesByIdDocumentQuery();
  const [isDownloading, setIsDownloading] = useState(false);

  // Check if ERP is configured for the selected tenant from session
  const selectedTenant = useAppSelector(selectSelectedTenant);
  const isErpConfigured = selectedTenant && selectedTenant !== 'all'
    ? !!selectedTenant.erpIntegrations?.some((erp) => erp.configured)
    : false;

  const handleOpenInvoice = useCallback(() => {
    setIsDownloading(true);
    getInvoicesByIdDocument({ id: invoice.invoiceId })
      .unwrap()
      .then((blobUrl) => {
        const link = document.createElement('a');
        link.href = blobUrl as string;
        link.download = invoice.invoiceNumber.toString();
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        toast.error(t(`server.FETCH_ERROR`), { id: 'global-error' });
      })
      .finally(() => {
        setIsDownloading(false);
      });
  }, [getInvoicesByIdDocument, invoice.invoiceId]);

  return (
    <TableRow className="bg-surface-base border-b border-surface-elevated">
      <TableCell className="px-2 py-2"></TableCell>
      <TableCell className="px-2 py-2"></TableCell>
      <TableCell className="px-2 py-2"></TableCell>
      <TableCell className="px-2 py-2 align-top">
        {invoice.amountOutstanding.value.toLocaleString('no', {
          style: 'currency',
          currency: invoice.amountOutstanding.currency,
          maximumFractionDigits: 0,
        })}
      </TableCell>
      <TableCell className="px-2 py-2">-</TableCell>
      <TableCell className={`px-2 py-2 align-top ${isErpConfigured ? '!text-brand-primary underline' : ''}`}>
        {!isErpConfigured ? (
          <span className="!text-foreground-secondary">-</span>
        ) : isDownloading ? (
          <span className="inline-flex items-center gap-1">
            <Spinner size="xs" />
            {tReporting('downloading')}
          </span>
        ) : (
          <a onClick={handleOpenInvoice} className="cursor-pointer">
            #{invoice.invoiceNumber}
          </a>
        )}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">{invoice.invoiceText}</TableCell>
      <TableCell className={`px-2 py-2 align-top !text-[${colors.status.error}]`}>{invoice.dueDate}</TableCell>
    </TableRow>
  );
};
